import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Tabs,
} from "antd";
import getObj from "lodash/get";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "services/axios";
import "../../../assets/styles/style.css";

import "../../../assets/style/image.css";
import PhotoDocument from "./PhotoComponent/PhotoDocument";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { formatNumber, formatRupiah } from "../../Utils";
import { Link } from "react-router-dom";

const httpFromHttps = (url) => url.replace("http://", "https://");

const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};
const TabPane = Tabs.TabPane;

class Appraisal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      priceMin: 0,
      carInquiry: {},
      appraisal: {},
      photo: {},
      showModalImage: false,
      disableForm: false,
      imageStyle: { backgroundImage: "", backgroundPosition: "0% 0%" },
    };
    this.setPhotoModalVisible = this.setPhotoModalVisible.bind(this);
  }

  componentDidMount() {
    axios
      .get(`/admin-panel/appraisal/${this.props.match.params.id}`)
      .then((result) => {
        this.setState({
          appraisal: result.data.appraisal,
          carInquiry: result.data.appraisal.Booking.CarInquiry,
          disableForm: result.data.appraisal.misc.priceConfirmation.status,
        });
        let mobbiCarPricingId = _.get(
          result.data.appraisal,
          "Booking.MobbiPayload.mobbiCarPricingId"
        );
        if (mobbiCarPricingId) {
          axios
            .get(`/admin-panel/mobbi/car/${mobbiCarPricingId}`)
            .then((res) => {
              let priceMax = _.get(res, "data.car.priceMax");
              this.setState({
                priceMin: priceMax ? priceMax * (90 / 100) || 0 : 0,
              });
            });
        } else {
          let spec = _.find(result.data.appraisal.carSummary, {
            fieldName: "Tipe",
          });
          let tahun = _.find(result.data.appraisal.carSummary, {
            fieldName: "Tahun",
          });
          if (spec && spec.value) {
            axios
              .get(
                `/value-car/spec/${spec.value}?areaPricingId=${this.state.appraisal.Booking.SalesProfile.Branch.areaPricingId}`
              )
              .then((resultSpec) => {
                let listHarga = resultSpec.data.carYear;
                let harga = _.find(listHarga, { year: tahun.value });
                this.setState({
                  priceMin: harga ? harga.priceMin : 0,
                });
              });
          }
        }
      })
      .catch((err) => {
        message.error("Gagal request data appraisal");
      });
  }

  getCarInquiry = (id) => {
    axios.get(`car-inquiry/${id}`).then((response) => {
      this.setState({
        carInquiry: {
          price: response.carInquiry.price,
          notes: response.carInquiry.notes,
        },
      });
    });
  };

  setPhotoModalVisible = (key, photo = {}) => {
    this.setState({
      showModalImage: key,
      photo,
      imageStyle: {
        ...this.state.imageStyle,
        backgroundImage: key ? `url(${httpFromHttps(photo.imageUrl)})` : "",
      },
    });
  };

  handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    this.setState({
      imageStyle: {
        ...this.state.imageStyle,
        backgroundPosition: `${x}% ${y}%`,
      },
    });
  };

  handleSubmit(e) {
    const { appraisal } = this.state;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
      } else {
        let miscConfirmation = appraisal.misc;
        miscConfirmation.priceConfirmation.status = true;
        miscConfirmation.priceConfirmation.timestamp = new Date();
        let payload = {
          ...values,
          bookingId: appraisal.bookingId,
          carType: appraisal.Booking.carType,
          licensePlate: appraisal.carDetail[7].value,
          year: appraisal.carDetail[6].value,
          KM: +appraisal.carDetail[11].value
            ? appraisal.carDetail[11].value.replace(".", "")
            : 0,
          miscConfirmation,
          appraisalId: appraisal.id,
        };
        axios
          .post("/car-inquiry/create", payload)
          .then((inquiry) => {
            this.setState({
              carInquiry: { price: inquiry.price, notes: inquiry.notes },
            });
            this.props.history.push("/home/appraisal");
            message.success("Berhasil update inquiry");
          })
          .catch((e) => {
            console.log(e);
          });
      }
    });
  }

  formatStatus = (status) => {
    switch (status) {
      case "FINISHED":
      case "CANCEL":
        return status;
      case "ASSIGNED":
        return "WAITING";
      default:
        return null;
    }
  };

  formatValue = (data) => {
    let value = "";
    if (data) {
      if (data.fieldName === "Nilai Pajak" && data.value) {
        value = formatRupiah(data.value);
      } else {
        value = data.value || "";
      }
    }
    return value;
  };

  async downloadPayload() {
    let mobbiPayload = _.get(this.state.appraisal, "Booking.MobbiPayload");
    if (mobbiPayload.mobbiData) {
      let fileName = "Payload Mobbi " + mobbiPayload.mobbiId || "";
      let json;
      if (mobbiPayload.payload) json = JSON.stringify(mobbiPayload.payload);
      else json = JSON.stringify(mobbiPayload.mobbiData);

      let blob = new Blob([json], { type: "application/json" });
      let href = await URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = href;
      link.download = fileName + ".json";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      message.success("Success Download Payload");
    } else {
      message.error("Error Download Payload");
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { appraisal, photo, disableForm, carInquiry } = this.state;
    let carData = [
      "carDetail[7]",
      "carDetail[3]",
      "carDetail[4]",
      "carDetail[5]",
      "carDetail[10]",
      "carDetail[8]",
      "carDetail[9]",
      "carDetail[6]",
      "carDetail[11]",
      "carDetail[12]",
      "carDetail[17]",
      "carDetail[18]",
      "carDetail[19]",
    ];

    let isMobbi = false,
      fuel,
      transmission,
      ccUnit,
      gardanUnit,
      recomendationPrice,
      mobbiId,
      mobbiPDF = "";

    let mobbiPayload = _.get(appraisal, "Booking.MobbiPayload");
    if (mobbiPayload) {
      isMobbi = true;
      fuel = _.get(mobbiPayload, "mobbiData.vehicleInformation.fuel");
      transmission = _.get(
        mobbiPayload,
        "mobbiData.vehicleInformation.transmission"
      );
      ccUnit = _.get(
        mobbiPayload,
        "mobbiData.vehicleInformation.engineCapacity"
      );
      gardanUnit = _.get(
        mobbiPayload,
        "mobbiData.vehicleInformation.driveSystem"
      );
      recomendationPrice = _.get(mobbiPayload, "recommendationPrice");
      mobbiPDF = _.get(mobbiPayload, "mobbiData.inspectionPDF");
      if (!mobbiPDF || mobbiPDF == "") {
        mobbiPDF = _.get(mobbiPayload, "inspectionResultPDF");
      }
      mobbiId = mobbiPayload.mobbiId;

      carData = [
        "carDetail[7]",
        "carDetail[3]",
        "carDetail[4]",
        "carDetail[5]",
        "carDetail[10]",
        "carDetail[6]",
        "carDetail[11]",
        "carDetail[12]",
        "carDetail[17]",
        "carDetail[18]",
        "carDetail[19]",
      ];
    }

    return appraisal.id ? (
      <Card
        title="TRADE IN MOBIL BARU"
        extra={
          <div>
            {isMobbi && (
              <Button
                type="primary"
                ghost={true}
                onClick={() => this.downloadPayload()}
                style={{ marginRight: 10 }}>
                Download JSON Mobbi
              </Button>
            )}

            {isMobbi && mobbiPDF && mobbiPDF != "" && (
              <Button
                type="primary"
                ghost={true}
                href={mobbiPDF}
                target="blank"
                style={{ marginRight: 10 }}>
                Mobbi PDF
              </Button>
            )}

            <Button
              type="primary"
              ghost={true}
              href={`https://s3-ap-southeast-1.amazonaws.com/toyota-trust-id/Detail-Appraisal-${appraisal.id}.pdf`}
              target="blank">
              Save as PDF
            </Button>
          </div>
        }>
        <div id="AppraisalDetail">
          <Row>
            <Card title="Status Appraisal">
              <Col xs={24} md={12}>
                <FormItem label="Status">
                  <span className="ant-form-text form-text-mod">
                    {this.formatStatus(appraisal.status)}
                  </span>
                </FormItem>
              </Col>
              {appraisal.status === "CANCEL" && (
                <Col xs={24} md={12}>
                  <FormItem label="Alasan Cancel">
                    <span className="ant-form-text form-text-mod">
                      {appraisal.Booking.cancelReason}
                    </span>
                    {appraisal.Booking.cancelReason === "Other" && (
                      <span className="ant-form-text form-text-mod">
                        &nbsp;- {appraisal.Booking.cancelNotes}
                      </span>
                    )}
                  </FormItem>
                </Col>
              )}
            </Card>
          </Row>

          <Row>
            <Col xs={24} md={12}>
              <Card title="CUSTOMER">
                {["carDetail[0]", "carDetail[2]", "carDetail[1]"].map(
                  (field, index) => (
                    <FormItem
                      key={index}
                      label={getObj(appraisal, field).fieldName}>
                      <span className="ant-form-text form-text-mod">
                        {getObj(appraisal, field).value}
                      </span>
                    </FormItem>
                  )
                )}
                <FormItem label="Mobil Baru">
                  <span className="ant-form-text form-text-mod">
                    {getObj(appraisal, "Booking.NewCar.carName")}
                  </span>
                </FormItem>
              </Card>
            </Col>

            <Col xs={24} md={12}>
              <Card title="SALES">
                {
                  //   [
                  //     {fieldName: "Sales Name", value: "Booking.SalesProfile.name"},
                  //     {fieldName: "Sales Phone", value: "Booking.SalesProfile.phone"},
                  // ]
                }
                <FormItem label="Sales Name">
                  <span className="ant-form-text form-text-mod">
                    {getObj(appraisal, "Booking.SalesProfile.name")}
                  </span>
                </FormItem>
                <FormItem label="Sales Branch">
                  <span className="ant-form-text form-text-mod">
                    {getObj(appraisal, "Booking.SalesProfile.branch")}
                  </span>
                </FormItem>
                <FormItem label="Sales Phone">
                  <span className="ant-form-text form-text-mod">
                    {getObj(appraisal, "Booking.SalesProfile.phone")}
                  </span>
                </FormItem>
              </Card>
            </Col>
          </Row>
          <Row>
            <Card title="MOBIL LAMA">
              <Col xs={24} md={12}>
                {carData &&
                  carData.map((field, index) => (
                    <FormItem
                      key={index}
                      label={getObj(appraisal, field).fieldName}>
                      <span className="ant-form-text form-text-mod">
                        {getObj(appraisal, field).fieldName == "Beda Alamat"
                          ? getObj(appraisal, field).value == 0
                            ? "Ya"
                            : "Tidak"
                          : getObj(appraisal, field).fieldName == "Pajak"
                          ? getObj(appraisal, field).value == 0
                            ? "Kurang dari 3 Bulan"
                            : getObj(appraisal, field).value == 1
                            ? "Pajak Mati"
                            : "Lebih dari 3 Bulan"
                          : getObj(appraisal, field).fieldName == "Status Pajak"
                          ? getObj(appraisal, field).value == 0
                            ? "Blokir"
                            : "Tidak"
                          : getObj(appraisal, field).fieldName == "Jarak Tempuh"
                          ? formatNumber(getObj(appraisal, field).value)
                          : getObj(appraisal, field).value}
                      </span>
                    </FormItem>
                  ))}

                {isMobbi && (
                  <React.Fragment>
                    <FormItem key="fuel" label="Fuel">
                      <span className="ant-form-text form-text-mod">
                        {fuel}
                      </span>
                    </FormItem>
                    <FormItem key="transmission" label="Transmission">
                      <span className="ant-form-text form-text-mod">
                        {transmission}
                      </span>
                    </FormItem>
                    <FormItem key="gardan" label="Gardan Unit">
                      <span className="ant-form-text form-text-mod">
                        {gardanUnit}
                      </span>
                    </FormItem>
                    <FormItem key="cc" label="CC Unit">
                      <span className="ant-form-text form-text-mod">
                        {formatNumber(ccUnit)}
                      </span>
                    </FormItem>
                  </React.Fragment>
                )}
              </Col>
              <Col xs={24} md={12}>
                {[
                  "overView[0]",
                  "overView[1]",
                  "overView[2]",
                  "overView[3]",
                  "overView[4]",
                  "overView[5]",
                  "overView[6]",
                  "overView[7]",
                  "overView[8]",
                  "overView[9]",
                  "overView[10]",
                  "overView[11]",
                  "carSummary[8]",
                ].map((field, index) => (
                  <FormItem
                    key={index}
                    label={getObj(appraisal, field).fieldName}>
                    <span className="ant-form-text form-text-mod">
                      {getObj(appraisal, field).type == "select"
                        ? _.find(getObj(appraisal, field).list, {
                            value: getObj(appraisal, field).value,
                          })
                          ? _.find(getObj(appraisal, field).list, {
                              value: getObj(appraisal, field).value,
                            }).name
                          : null
                        : this.formatValue(getObj(appraisal, field))}
                    </span>
                  </FormItem>
                ))}

                {isMobbi &&
                  ["carDetail[8]", "carDetail[9]"].map((field, index) => (
                    <FormItem
                      key={index}
                      label={getObj(appraisal, field).fieldName}>
                      <span className="ant-form-text form-text-mod">
                        {getObj(appraisal, field).value}
                      </span>
                    </FormItem>
                  ))}
              </Col>
            </Card>
          </Row>
          <Row>
            <Col xs={24} md={12}>
              <Card title="TRADEIN MOBIL BARU">
                <h2>Tidak ada detail mobil</h2>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="DATA APPRAISAL">
                {
                  // [
                  //   {fieldName: "Tanggal Appraiser", value: "Booking.bookingTime"},
                  // ]
                }
                <FormItem label="Tanggal Appraiser">
                  <span className="ant-form-text form-text-mod">
                    {moment(getObj(appraisal, "Booking.bookingTime")).format(
                      "dddd, D MMMM YYYY"
                    )}{" "}
                    {moment(getObj(appraisal, "Booking.bookingTime")).format(
                      "HH : mm"
                    )}
                  </span>
                </FormItem>
                <FormItem label="Nama Appraiser">
                  <span className="ant-form-text form-text-mod">
                    {getObj(appraisal, "Booking.Appraiser.name")}
                  </span>
                </FormItem>
              </Card>
            </Col>
          </Row>
          {isMobbi && (
            <Row>
              <Col xs={24} md={24}>
                <Card
                  title="Mobbi Information"
                  headStyle={{ backgroundColor: "#034F8A", color: "white" }}
                  bodyStyle={{ backgroundColor: "#FFBA3A" }}
                  color="white">
                  <Col xs={24} md={12}>
                    <Form.Item label="Rekomendasi Harga dari Mobbi">
                      <span
                        className="ant-form-text form-text-mod"
                        style={{ lineHeight: "30px" }}>
                        {formatRupiah(recomendationPrice) || "Rp.0"}
                      </span>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12}>
                    <Form.Item label="Mobbi Id">
                      <span
                        className="ant-form-text form-text-mod"
                        style={{ lineHeight: "30px" }}>
                        {mobbiId || "-"}
                      </span>
                    </Form.Item>
                  </Col>
                </Card>
              </Col>
            </Row>
          )}
        </div>
        <Row>
          <Col xs={24} md={24}>
            <Card>
              <Tabs defaultActiveKey="1" onChange={this.onChangeTabs}>
                <TabPane forceRender={true} tab="Kendaraan" key="1">
                  <div id="photo-doc-print">
                    {appraisal.photoDocument ? (
                      <PhotoDocument
                        photos={appraisal.photoDocument}
                        appraisalId={appraisal.id}
                        photoModal={this.setPhotoModalVisible}
                        tab="Kendaraan"
                        isMobbi={isMobbi}
                      />
                    ) : (
                      <PhotoDocument
                        photos={appraisal.carDetail}
                        appraisalId={appraisal.id}
                        photoModal={this.setPhotoModalVisible}
                        tab="Kendaraan"
                        isMobbi={isMobbi}
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Frame" key="2">
                  <div id="photo-frame-print">
                    <PhotoDocument
                      photos={appraisal.photoFrame}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                      tab="Frame"
                      isMobbi={isMobbi}
                    />
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Engine" key="3">
                  <div id="photo-engine-print">
                    <PhotoDocument
                      photos={appraisal.photoEngine}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                      tab="Engine"
                      isMobbi={isMobbi}
                    />
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Interior" key="4">
                  <div id="photo-interior-print">
                    <PhotoDocument
                      photos={appraisal.photoInterior}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                      tab="Interior"
                      isMobbi={isMobbi}
                    />
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Exterior" key="5">
                  <div id="photo-exterior-print">
                    <PhotoDocument
                      photos={appraisal.photoExterior}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                      tab="Exterior"
                      isMobbi={isMobbi}
                    />
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Harga Mobil" key="6">
                  <div id="photo-exterior-print">
                    <PhotoDocument
                      photos={appraisal.finalPrice}
                      appraisal={appraisal}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                      tab="Harga"
                      priceMin={this.state.priceMin}
                      isMobbi={isMobbi}
                    />
                  </div>
                </TabPane>
                {isMobbi && (
                  <TabPane forceRender={true} tab="Other" key="7">
                    <div id="photo-other-print">
                      <PhotoDocument
                        photos={appraisal}
                        appraisalId={appraisal.id}
                        photoModal={this.setPhotoModalVisible}
                        tab="Other"
                        isMobbi={isMobbi}
                      />
                    </div>
                  </TabPane>
                )}

                {isMobbi && (
                  <TabPane
                    forceRender={true}
                    tab="Rekomendasi tambahan Mobbi88"
                    key="8">
                    <div id="photo-rekomendari-mobbi88-print">
                      <PhotoDocument
                        photos={appraisal}
                        appraisalId={appraisal.id}
                        photoModal={this.setPhotoModalVisible}
                        tab="Rekomendasi tambahan Mobbi88"
                        isMobbi={isMobbi}
                      />
                    </div>
                  </TabPane>
                )}

                {isMobbi && (
                  <TabPane forceRender={true} tab="Foto dari Mobbi88" key="9">
                    <div id="photo-mobbi88-print">
                      <PhotoDocument
                        photos={appraisal}
                        appraisalId={appraisal.id}
                        photoModal={this.setPhotoModalVisible}
                        tab="Foto dari Mobbi88"
                        isMobbi={isMobbi}
                      />
                    </div>
                  </TabPane>
                )}
              </Tabs>
            </Card>
          </Col>
        </Row>
        {/* <Row>
          <Col xs={24} md={24}>
            <Card title="Harga Mobil">
              <FormItem label="Harga Awal">
                <span className="ant-form-text form-text-mod">{ appraisal.finalPrice.hargaMobil }</span>
              </FormItem>

              <FormItem label="Harga Setelah Nego">
                <span className="ant-form-text form-text-mod">{ appraisal.finalPrice.hargaFinal }</span>
              </FormItem>
            </Card>
          </Col>
          </Row> */}

        <div id="imgCanvas" />

        {/* <Card title="Create Car Inquiry">
          <Form layout="horizontal" style={{ marginTop: "30px" }} onSubmit={e => this.handleSubmit(e)}>
            <FormItem label="Harga" {...formItemLayout}>
              {getFieldDecorator("price", {
                rules: [{ required: true, message: "Harga is required" }],
                initialValue: carInquiry ? carInquiry.price : "",
              })(
                <InputNumber
                  disabled={disableForm}
                  style={{ width: "100%" }}
                  formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                />,
              )}
            </FormItem>

            <FormItem label="Catatan" {...formItemLayout}>
              {getFieldDecorator("notes", { initialValue: carInquiry ? carInquiry.notes : "" })(
                <Input.TextArea disabled={disableForm} rows={8} />,
              )}
            </FormItem>

            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form>
        </Card> */}

        {this.state.showModalImage && (
          <Lightbox
            mainSrc={photo.imageUrl}
            onCloseRequest={() => this.setPhotoModalVisible(false)}
          />
        )}
      </Card>
    ) : null;
  }
}

const FormAppraisalInquiry = Form.create()(Appraisal);

const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(FormAppraisalInquiry);



// WEBPACK FOOTER //
// src/components/Dashboard/Appraisal/AppraisalDetail.js